import { commonActions } from '../app/actions';

export const setOfferClicked = () => (dispatch) => {
  const { setValue } = commonActions('offer_clicked');
  dispatch(setValue());
};
